import { createApp } from 'vue'
import service from '@/views/area_volume/service.vue'
import '@/assets/css/index.css'
import i18n from '@/i18n/i18n'

createApp(service).use(i18n).mount('#app')
